import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Box, Flex } from '../../../../units/Box/Box';
import Text from '../../../../units/Text/Text';
import Button from '../../../../units/Button/Button';
import TableContent from '../../../../units/TableContent/TableContent';

import FormDropdown from '../../FormControls//FormDropdown/FormDropdown';

import { FormTitle } from '../../FormUnits/FormUnits';

import withForm from '../../../../hocs/withForm';

import OrgsDropdownItems from './OrgsDropdownItems/OrgsDropdownItems';
import OrgsDropdownValue from './OrgsDropdownValue/OrgsDropdownValue';

const FormActions = {
  next: {
    actionId: 'next',
    isActionSubmit: true
  }
};

class RegistratUserOrgResultForm extends Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    getFieldProps: PropTypes.func.isRequired,
    getActionProps: PropTypes.func.isRequired,
    applyAction: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired
  };

  confirmOrganization = async values => {
    await this.props.applyAction({
      actionId: 'next',
      values
    });
  };

  renderTitle = orgs => {
    if (orgs) {
      const amountOrgs = orgs.length;

      if (amountOrgs > 1) {
        const org = amountOrgs === 5 ? 'организаций' : 'организации';

        return `Найдено ${amountOrgs} ${org}`;
      }
    }

    return 'Подтвердите данные организации';
  };

  renderOrganization = org => {
    return (
      <TableContent
        items={[
          {
            label: 'Полное наименование',
            value: org.fullName
          },
          {
            label: 'Сокращенное наименование',
            value: org.shortName
          },
          {
            label: 'Адрес',
            value: org.address
          },
          {
            label: 'ОГРН',
            value: org.ogrn
          },
          {
            label: 'ИНН',
            value: org.inn
          },
          {
            label: 'КПП',
            value: org.kpp
          },
          {
            label: 'Руководитель',
            value: org.executive,
            description: org.position
          }
        ]}
      />
    );
  };

  renderSelectOrganization = orgs => {
    const { getFieldProps } = this.props;

    return (
      <Flex mt="-15px" align="center" column>
        <Text className="RegistratUserOrgResult__title">
          Выберите нужную организацию и проверьте правильность данных:
        </Text>

        <Box m="25px 0 20px">
          <FormDropdown
            items={orgs.map(item => ({
              value: item.id,
              name: item.values[0],
              kpp: item.values[1],
              address: item.values[2]
            }))}
            width="600px"
            size="medium"
            itemsTemplate={<OrgsDropdownItems />}
            valueTemplate={<OrgsDropdownValue />}
            {...getFieldProps('selectOrg')}
          />
        </Box>
      </Flex>
    );
  };

  renderOrganizations = (orgs, currentOrg) => {
    return (
      <Box>
        {orgs && orgs.length > 1 && this.renderSelectOrganization(orgs)}
        {this.renderOrganization(currentOrg)}
      </Box>
    );
  };

  render() {
    const { getActionProps } = this.props;
    const { items } = this.props.fields.selectOrg;
    const {
      address,
      executive,
      fullName,
      inn,
      kpp,
      ogrn,
      position,
      shortName
    } = this.props.fields;

    const currentOrg = {
      address: address.value,
      executive: executive.value,
      fullName: fullName.value,
      inn: inn.value,
      kpp: kpp.value,
      ogrn: ogrn.value,
      position: position.value,
      shortName: shortName.value
    };

    return (
      <Flex align="center" column className="zeroClient_step_orgInfoConfirm">
        <FormTitle className="form-title_user-org-confirm">
          {this.renderTitle(items)}
        </FormTitle>

        <Flex column>
          <Box width="600px">{this.renderOrganizations(items, currentOrg)}</Box>

          <Flex justify="center" mt="10px">
            <Button
              onClick={this.props.handleSubmit(this.confirmOrganization)}
              size="large"
              font="caption"
              bold
              {...getActionProps(FormActions.next)}
            >
              Подтвердить
            </Button>
          </Flex>
        </Flex>
      </Flex>
    );
  }
}

export default withForm(RegistratUserOrgResultForm);



// WEBPACK FOOTER //
// ./src/components/containers/Forms/FormsComponents/RegistratUserOrgResult/RegistratUserOrgResult.js